export default "/acfdf2704e412c85fb550b6408622629b62bf7b2/c5d6534f4f2cb925009575e748220704.svg";